import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import Input from '../common/Input';
import SelectBox from '../common/SelectBox';
import { STUDENTS_ROWS } from '../../constants/constants';
import { getStudents } from '../../actions/studentActions';
import { getCycles } from '../../actions/cycleActions';
import { getGradeInstances } from '../../actions/gradeInstanceActions';
import { toSelect } from '../../utils/helpers';

class StudentSearch extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      filters: {
        name: '',
        cycle: '',
        gradeInstance: ''
      },
      timeout: {},
      currentCycle: {}
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  componentWillMount() {
    const { cycles, getCycles, getGradeInstances } = this.props;
    _.isEmpty(cycles) && getCycles();
    getGradeInstances();
  }

  onSubmit() {
    const { getStudents } = this.props;
    const { filters } = this.state;
    getStudents(filters, STUDENTS_ROWS);
  }

  onChange(field) {
    return (e) => {
      const value = field === 'name' ? e.target.value : e;
      const { filters } = this.state;
      filters[field] = value;
      if (field === 'name') {
        let { timeout } = this.state;
        clearTimeout(timeout);
        timeout = setTimeout(this.onSubmit, 500);
        this.setState({ timeout });
      }
      if (field === 'cycle') {
        const { cycles } = this.props;
        const currentCycle = _.find(cycles, cycle => cycle.id === value);
        this.setState({ currentCycle });
        filters.gradeInstance = '';
      }
      this.setState({ filters });
    };
  }

  onKeyPress(e) {
    if (e.key === 'Enter') {
      this.onSubmit();
    }
  }

  onClear() {
    const filters = {
      name: '',
      cycle: '',
      gradeInstance: ''
    };
    this.setState({ filters }, this.onSubmit);
  }

  render() {
    const { currentCycle, filters: { name, cycle, gradeInstance } } = this.state;
    const { onChange, onSubmit, onKeyPress, onClear } = this;
    const { cycles, gradeInstances } = this.props;
    const nameInput = {
      value: name,
      name: 'name',
      onChange: onChange('name'),
      onKeyPress
    };
    const cycleInput = {
      value: cycle,
      name: 'cycle',
      onChange: onChange('cycle')
    };
    const gradeInput = {
      value: gradeInstance,
      name: 'gradeInstance',
      onChange: onChange('gradeInstance')
    };
    const meta = { touched: false };
    const currentGrades = gradeInstances.filter(
      grade => grade.get('cycleId') === currentCycle.id
    ).toJS();

    return (
      <div className="searcher">
        <div>
          <Input
            type="text"
            placeholder="Nombre o apellido"
            input={nameInput}
            meta={meta}
          />
          <SelectBox
            placeholder="Ciclo"
            options={toSelect(cycles)}
            input={cycleInput}
            meta={meta}
          />
          <SelectBox
            placeholder="Clase"
            options={currentCycle ? toSelect(currentGrades) : []}
            input={gradeInput}
            meta={meta}
          />
        </div>
        <div>
          <button className="default-button" onClick={onClear}>Limpiar</button>
          <button className="default-button" onClick={onSubmit}>Buscar</button>
        </div>
      </div>
    );
  }
}

const { array, func, object } = PropTypes;

StudentSearch.propTypes = {
  getCycles: func.isRequired,
  getGradeInstances: func.isRequired,
  getStudents: func.isRequired,
  gradeInstances: object.isRequired,
  cycles: array.isRequired
};

const mapState = state => ({
  cycles: state.get('cycle').toJS(),
  gradeInstances: state.getIn(['gradeInstance', 'gradeInstances'])
});

const mapDispatch = dispatch => ({
  getCycles: () => dispatch(getCycles()),
  getStudents: (filters, rows) => dispatch(getStudents(filters, rows)),
  getGradeInstances: () => dispatch(getGradeInstances())
});

export default connect(mapState, mapDispatch)(StudentSearch);



// WEBPACK FOOTER //
// ./src/components/student/StudentSearch.js